import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { NbDialogService } from '@nebular/theme';
import { OfbizForm, OfbizFormsService } from '@urbannex/ofbiz-forms';
import { OutputFileType } from 'typescript';
import { LookupDialogContainerComponent } from '../../lookup-dialog-container/lookup-dialog-container.component';
import { ComponentConfig, SelectedValue } from '../../shared/model';
import { UbsComponentStoreService } from '../../ubs-component-store.service';
import { FormBuilder, FormControl } from '@angular/forms';
import { take } from 'rxjs';

@Component({
  selector: 'ubs-relation-form-container',
  templateUrl: './relation-form-container.component.html',
  styleUrls: ['./relation-form-container.component.scss']
})
export class RelationFormContainerComponent implements OnInit,OnChanges {
  @Input() addForm:OfbizForm;
  @Input() parameters:any;
  @Input() addContainerTitle:string;
  @Input() lookupFieldResult:any;
  @Input() selectedValue:SelectedValue
  @Input() appContext:string;
  state:any;
  target:string;
  tempForm = this.fb.group({});
  title:string

  @Output() refreshList = new EventEmitter<string>();
  @Output() formSubmitResult = new EventEmitter<string>();

  constructor(
    private componentStore:UbsComponentStoreService,
    private fb:FormBuilder,
    private ofbizFormsService:OfbizFormsService,
    private dialogService: NbDialogService,) { }

  ngOnInit(): void {
    this.componentStore.vm$.subscribe(data => {
      this.state = data;
    })
  }

  openDialogContainer(data):void{
    console.log({TrackDialog:{component:"RelationFormContainerComponent",data:data}});
    let componentConfig:ComponentConfig = this.state.componentConfig;
    this.dialogService.open(LookupDialogContainerComponent, {
      context:{
        componentConfig:componentConfig,
        data:data
      },
      dialogClass:'modal-full',
    })
  }

  submitResult(e){
    console.log({RefreshList:e,Component:"RelationFormContainerComponent",Comment:"Emitting after form submit"})
    this.refreshList.emit(e);
    this.formSubmitResult.emit(e)
  }

  ngOnChanges(changes: SimpleChanges): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if(changes["addForm"]){
      console.log({TrackAddForm:this.addForm})
      let targets = this.addForm.targets? this.addForm.targets : null;
      if(targets != null){
        console.log({Targets:targets});
        this.target = targets["createTarget"];
      }else if(this.addForm.target != null && this.addForm.target != undefined){
        this.target = this.addForm.target;
      }
      console.log({Target:this.target});
    }
    if(changes["addContainerTitle"]){
      console.log(this.title);
      this.title = this.addContainerTitle;
    }
    if(changes["selectedValue"]){
      console.log({TrackSelectedValue:this.selectedValue});
      if(this.selectedValue != null && this.selectedValue != undefined){
        //Ensure that the title is reset
        //this.title = "";
        this.parameters = this.selectedValue.data.parameters;
        this.getValue(this.selectedValue);
      }
    }
    if(changes["lookupFieldResult"]){
      console.log({TrackLookupResult:this.lookupFieldResult});
    }
    if(changes["parameters"]){
      console.log({TrackParameters:this.parameters});
    }
    

  }

  getValue(selectedValue:SelectedValue){
    let formData = selectedValue.data.formData;
    let endPoint = selectedValue.data.endPoint? selectedValue.data.endPoint : "";
    let parameters = selectedValue.data.parameters;
    if(parameters != undefined){
      Object.keys(parameters).forEach(key =>{
        if(this.tempForm.get(key)){
          console.log("Field exists",this.tempForm.get(key),{key:parameters[key]});
          this.tempForm.patchValue({[key]:parameters[key]});
        }else{
          this.tempForm.addControl(key,new FormControl(parameters[key]));
        }
      });
      console.log(this.tempForm.value);
    }
    console.log("Getting formData value",formData);
    this.ofbizFormsService.getValue(formData,this.tempForm.value,endPoint)
    .pipe(take(1))
    .subscribe(responseData => {
      const statusCode = responseData["statusCode"];
      switch (statusCode) {
        case 200:
          if(responseData["successMessage"] == "OK"){
            const data = responseData["data"];
            const formData = data["formData"];
            if(data["responseMessage"] == "success"){
              //this.responseMessage = "success";
              //let formFields:OfbizField[] = this.addForm.fields;
              let dataFields:any[] = formData["fields"];
              console.log(dataFields);
              this.parameters = dataFields;
              let titlePlaceHolder:any = {"description":"","id":""}
              this.addForm.fields.forEach(field => {
                let dataField = dataFields.find(element => field.name == Object.keys(element)[0]);
                if(dataField){
                  field.value = dataField[field.name];
                  if(field.name === this.addForm.titleDescriptionField){
                    titlePlaceHolder.description = dataField[field.name];
                  }
                  if(field.name === this.addForm.idFieldName){
                    titlePlaceHolder.id = dataField[field.name];
                  }
                }
              });
              console.log({AddFormAfter:this.addForm});
              if(this.addForm.actionsMenu != undefined){
                //this.processActionMenu();
                console.log(this.addForm.actionsMenu);
                //this.contextMenuItems = this.addForm.actionsMenu;
              }
              this.title = this.addContainerTitle +" "+titlePlaceHolder.description+" - ["+titlePlaceHolder.id+"]";
              console.log(this.title);
              //this.hasValue = true;
            }
          }
          break;
        case 404:
        
          break;
        case 500:
        
          break;
        default:
          break;
      }
    })
  }

}
